import { DateTime } from '@ksyos/date-time';
import { EpisodeCategory } from '../../common/enums/episodeCategory';
import { RequestStatus } from '../../common/enums/requestStatus';
import { ServiceCode } from '../../common/enums/serviceCode';
import { fetchJson } from '../store/fetch';

type FetchedRequestProcess = {
    code: ServiceCode;
    dateSent: string | null;
    status: RequestStatus;
};

export async function canCreateOsasvc(patientId: string) {
    let isOsasc2Completed = false;
    let isOsasoCompleted = false;
    let isOsasvoCompleted = false;

    const previousRequests = await fetchJson<{
        count: number;
        items: FetchedRequestProcess[];
    }>(
        `/api/requestProcesses?patientId=${patientId}&episodeCategory=${EpisodeCategory.somnology}&orderByCreatedAtDesc=true`,
        'GET',
        undefined,
        [],
        [400]
    );

    if (!previousRequests.errorCode) {
        const latestOsaso = previousRequests.json!.items.find(
            (item: { code: ServiceCode }) => item.code === ServiceCode.OSASO
        );
        const latestOsasvo = previousRequests.json!.items.find(
            (item: { code: ServiceCode }) => item.code === ServiceCode.OSASVO
        );
        const latestOsasc2 = previousRequests.json!.items.find(
            (item: { code: ServiceCode }) => item.code === ServiceCode.OSASC2
        );

        if (latestOsaso?.dateSent && latestOsasc2?.dateSent) {
            isOsasc2Completed =
                latestOsasc2?.status === RequestStatus.completed &&
                DateTime.from(latestOsaso.dateSent).isBefore(DateTime.from(latestOsasc2.dateSent));

            isOsasoCompleted = latestOsaso?.status === RequestStatus.completed;
        }

        if (latestOsasvo) {
            isOsasvoCompleted = latestOsasvo.status === RequestStatus.completed;
        }
    }

    return { isOsasc2Completed, isOsasoCompleted, isOsasvoCompleted };
}
